import React, {useEffect, useState} from "react";
import {
    AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay,
    Box,
    Button,
    Card,
    Flex,
    FormControl,
    FormLabel,
    Input,
    Stack,
    Table, Tbody, Td,
    Text,
    Th,
    Thead,
    Tr, useColorModeValue
} from "@chakra-ui/react";
import Pagination from "rc-pagination";
import {useNewCompany} from "../hooks/useNewCompany";
import {cloneDeep} from "lodash";
import {convertMasksFormat} from "../../../../../helpers/functions";

type NewUserTableProps = Pick<useNewCompany.type, "state" | "add" | "cancelRef" | "closeDelete" | "deleteCompany" | "editCompany">;

const NewCompanyTable: React.FC<NewUserTableProps> = ({
                                                          state,
                                                          add,
                                                          cancelRef,
                                                          closeDelete,
                                                          deleteCompany,
                                                          editCompany
                                                      }) => {
    const textColor = useColorModeValue("secondaryGray.900", "white");
    const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

    const countPerPage = 10;
    const [value, setValue] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [collection, setCollection] = useState(
        cloneDeep(state.companyList.slice(0, countPerPage))
    );

    const updatePage = (p: number) => {
        setCurrentPage(p);
        const to = countPerPage * p;
        const from = to - countPerPage;
        setCollection(cloneDeep(state.companyList.slice(from, to)));
    };

    useEffect(() => {
        const updatePage = (p: number) => {
            setCurrentPage(p);
            const to = countPerPage * p;
            const from = to - countPerPage;
            setCollection(cloneDeep(state.companyList.slice(from, to)));
        };

        const searchData = (val: string) => {
            const query = val.toLowerCase();
            setCurrentPage(1);
            const data =
                state.companyList
                    .filter(item => item?.razaoSocial.toLowerCase().includes(query) || item?.nomeFantasia.toLowerCase().includes(query))
                    .slice(0, countPerPage)
            setCollection(data);
        }

        if (!value) {
            updatePage(1);
        } else {
            searchData(value);
        }
    }, [state.companyList, value]);

    return (
        <Card flexDirection="column" overflowX={{sm: "scroll", lg: "hidden"}}>
            <Flex
                px="25px"
                mb="16px"
                mt="16px"
                justifyContent="space-between"
                align="center"
            >
                <Text
                    color={textColor}
                    fontSize="22px"
                    fontWeight="700"
                    lineHeight="100%"
                >
                    Listagem de Produtos
                </Text>
                <Button onClick={add} colorScheme="brand" variant="outline">
                    Adicionar
                </Button>
            </Flex>
            <Box>

                <Stack p={4}>
                    <FormControl>
                        <FormLabel
                            display="flex"
                            ms="4px"
                            fontSize="sm"
                            fontWeight="bold"
                            color={textColor}
                            mb="8px"

                        >
                            Buscar
                        </FormLabel>

                        <Input
                            fontSize="sm"
                            ms={{base: "0px", md: "0px"}}
                            type="text"
                            placeholder="Buscar"
                            fontWeight="500"
                            w={320}
                            size="md"
                            onChange={e => setValue(e.target.value)}
                            value={value}
                        />
                    </FormControl>
                </Stack>

                <Table variant="striped" color="gray.500" mb="24px" mt="12px">
                    <Thead>
                        <Tr>

                            <Th pe="10px" borderColor={borderColor} cursor="pointer">
                                <Flex
                                    justifyContent="space-between"
                                    align="center"
                                    fontSize={{sm: "10px", lg: "12px"}}
                                    color="gray.400"
                                >
                                    #RAZÃO SOCIAL
                                </Flex>
                            </Th>
                            <Th pe="10px" borderColor={borderColor} cursor="pointer">
                                <Flex
                                    justifyContent="space-between"
                                    align="center"
                                    fontSize={{sm: "10px", lg: "12px"}}
                                    color="gray.400"
                                >
                                    #NOME FANTASIA
                                </Flex>
                            </Th>
                            <Th pe="10px" borderColor={borderColor} cursor="pointer">
                                <Flex
                                    justifyContent="space-between"
                                    align="center"
                                    fontSize={{sm: "10px", lg: "12px"}}
                                    color="gray.400"
                                >
                                    #CNPJ
                                </Flex>
                            </Th>
                            <Th pe="10px" borderColor={borderColor} cursor="pointer">
                                <Flex
                                    justifyContent="space-between"
                                    align="center"
                                    fontSize={{sm: "10px", lg: "12px"}}
                                    color="gray.400"
                                >
                                    #ATIVO
                                </Flex>
                            </Th>
                            <Th pe="10px" borderColor={borderColor} cursor="pointer">
                                <Flex
                                    justifyContent="space-between"
                                    align="center"
                                    fontSize={{sm: "10px", lg: "12px"}}
                                    color="gray.400"
                                >
                                    #OPÇÕES
                                </Flex>
                            </Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {collection?.map((item, index) => {
                            return (
                                <Tr key={`${item.id}-${index}`}>
                                    <Td
                                        fontSize={{sm: "14px"}}
                                        borderColor="transparent"
                                    >
                                        {item?.razaoSocial}
                                    </Td>
                                    <Td
                                        fontSize={{sm: "14px"}}
                                        borderColor="transparent"
                                    >
                                        {item.nomeFantasia}
                                    </Td>

                                    <Td
                                        fontSize={{sm: "14px"}}
                                        borderColor="transparent"
                                    >
                                        {convertMasksFormat("cnpj", item?.cnpj)}
                                    </Td>
                                    <Td
                                        fontSize={{sm: "14px"}}
                                        borderColor="transparent"
                                    >
                                        {item?.ativo ? "Sim" : "Não"}
                                    </Td>
                                    <Td
                                        fontSize={{sm: "14px"}}
                                        borderColor="transparent"
                                    >
                                        <Button onClick={() => editCompany(item)} colorScheme="green" variant="ghost">
                                            Editar
                                        </Button>
                                        <Button onClick={() => deleteCompany(item)} colorScheme="red" variant="ghost"
                                                ml="1">
                                            Excluir
                                        </Button>
                                    </Td>
                                </Tr>
                            );
                        })}
                    </Tbody>
                </Table>


                <Pagination
                    pageSize={countPerPage}
                    onChange={updatePage}
                    current={currentPage}
                    total={state.companyList.length}
                    style={{
                        float: 'right',
                        marginRight: 24,
                        marginBottom: 24,
                    }}
                />

                <AlertDialog
                    isOpen={state.showDelete}
                    leastDestructiveRef={cancelRef}
                    onClose={closeDelete}
                    isCentered
                    motionPreset='slideInBottom'
                >
                    <AlertDialogOverlay>
                        <AlertDialogContent>
                            <AlertDialogHeader fontSize="lg" fontWeight="bold">
                                Cuidado!
                            </AlertDialogHeader>

                            <AlertDialogBody>
                                Deseja realmente deletar esse registro?
                            </AlertDialogBody>

                            <AlertDialogFooter>
                                <Button ref={cancelRef} onClick={closeDelete} colorScheme={'gray'}>
                                    Cancelar
                                </Button>
                                <Button ref={cancelRef} onClick={() => {
                                }} colorScheme={'red'}>
                                    Excluir
                                </Button>
                            </AlertDialogFooter>
                        </AlertDialogContent>
                    </AlertDialogOverlay>
                </AlertDialog>
            </Box>
        </Card>
    );
}

export default NewCompanyTable;
